import { render, staticRenderFns } from "./ns-quiq-chat-button-vue.vue?vue&type=template&id=5b6efd16&"
import script from "./ns-quiq-chat-button-vue.vue?vue&type=script&lang=js&"
export * from "./ns-quiq-chat-button-vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6efd16')) {
      api.createRecord('5b6efd16', component.options)
    } else {
      api.reload('5b6efd16', component.options)
    }
    module.hot.accept("./ns-quiq-chat-button-vue.vue?vue&type=template&id=5b6efd16&", function () {
      api.rerender('5b6efd16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-app-elements/src/ns-quiq-chat-button/ns-quiq-chat-button-vue.vue"
export default component.exports